import { render, staticRenderFns } from "./NivelesEducativos.vue?vue&type=template&id=7825474e&"
import script from "./NivelesEducativos.vue?vue&type=script&lang=js&"
export * from "./NivelesEducativos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports